import qs from 'qs';

import axiosInstance from '../protected-v1';

import {IPageable, IPageableDto} from '../../shared/types/pageable.types';
import {IAddressItem, IAddressItemParams} from '../../shared/types/addressItem.types';
import {getAddressItemUrl} from '../api.config';

export const AddressItemService = {
  async getAll(
    attr: {
      pageable?: IPageable;
      params?: IAddressItemParams;
    } = {},
  ) {
    const res = await axiosInstance.get<IPageableDto<IAddressItem>>(getAddressItemUrl(), {
      params: {
        ...attr.pageable,
        ...attr.params,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async getByCode(code: Pick<IAddressItem, 'itemType'>) {
    const res = await axiosInstance.get<IAddressItem>(getAddressItemUrl(`/${code}`));

    return res;
  },
};
